import React from "react";
import Card from "../ui/Card";
import Skeleton from "../ui/Skeleton";

export const OrganizationUsersSkeleton: React.FC = () => {
  return (
    <div className="w-full space-y-3">
      {/* Filter bar — busca + filtro de nível, grudada na description bar */}
      <div className="-mt-4 -mx-4 px-4 py-2 mb-4 bg-white/95 border-b border-purple-200">
        <div className="flex flex-row flex-wrap gap-2 items-center w-full">
          <div className="flex-1 min-w-[200px]">
            <Skeleton
              variant="rectangular"
              width="100%"
              height={36}
              className="rounded-xl"
            />
          </div>
          <Skeleton
            variant="rectangular"
            width={170}
            height={36}
            className="rounded-xl opacity-40"
          />
        </div>
      </div>

      <Card
        variant="elevated"
        className="overflow-hidden rounded-3xl border-purple-200 shadow-[0_8px_30px_-4px_rgba(0,0,0,0.04)] bg-white"
      >
        <div className="divide-y divide-purple-50">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="py-4 px-4 sm:px-6">
              <div className="flex items-center gap-4 flex-wrap lg:flex-nowrap">
                {/* Identidade */}
                <div className="flex items-center gap-4 min-w-0 flex-1">
                  <Skeleton
                    variant="rectangular"
                    width={44}
                    height={44}
                    className="rounded-xl shrink-0"
                  />
                  <div className="min-w-0 space-y-1.5">
                    <div className="flex items-center gap-2.5">
                      <Skeleton variant="text" width={130} height={16} />
                      <Skeleton
                        variant="rectangular"
                        width={50}
                        height={16}
                        className="rounded-full opacity-40"
                      />
                    </div>
                    <Skeleton variant="text" width={180} height={10} />
                  </div>
                </div>

                {/* Coluna "Desde" */}
                <div className="hidden md:flex flex-col shrink-0 w-24 gap-1">
                  <Skeleton variant="text" width={40} height={8} />
                  <Skeleton variant="text" width={70} height={12} />
                </div>

                {/* Controles */}
                <div className="flex flex-wrap items-center gap-2 shrink-0">
                  <Skeleton
                    variant="rectangular"
                    width={132}
                    height={36}
                    className="rounded-xl opacity-40"
                  />
                  <Skeleton
                    variant="rectangular"
                    width={36}
                    height={36}
                    className="rounded-xl opacity-30"
                  />
                  <Skeleton
                    variant="rectangular"
                    width={36}
                    height={36}
                    className="rounded-xl opacity-30"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default OrganizationUsersSkeleton;
